import { NEWS_TYPE } from '../constants';
import { LANG_NUM_MAP } from '../constants/i18n';
import { safeStringify } from '@futuweb/fimoo-shared';
import { uniq } from 'lodash-es';
import { isCurrentAreaUrl } from '../utils';
const {
    common: {
        request: { bindCommonApi }
    }
} = require('@futuweb/fego-render');

const commonApiRequest = bindCommonApi('web-news-list');

export function useRenderNews(props) {
    const newsInfoMap = new Map();
    /** 获取要闻数据 */
    async function getMarketData() {
        const data = await commonApiRequest.get(
            'list',
            {
                lang: LANG_NUM_MAP[props.language],
                size: props.showCount
            },
            {
                group: null
            }
        );
        return (
            data &&
            data.list.map((item) => {
                return {
                    ...item,
                    time: item.timestamp
                };
            })
        );
    }

    /** 获取关联个股数据 */
    async function getNewsStockData() {
        const data = await commonApiRequest.get(
            'stockNewsList',
            {
                lang: LANG_NUM_MAP[props.language],
                size: props.showCount,
                stockId: props.stockId
            },
            {
                group: null
            }
        );
        return (
            data &&
            data.news.map((item) => {
                return {
                    ...item,
                    title: item.buffTitle,
                    time: item.dwTime,
                    url: item.buffUrl
                };
            })
        );
    }

    /** 获取自定义文章数据 */
    async function getNewsData() {
        const customUrls = props.customList?.map((item) => item.url) || [];
        // 通过url获取新闻唯一ID，url => newsUniqueId
        const uniqueIDData = await commonApiRequest.get(
            'newsUniqueIDByURL',
            {
                url: safeStringify(customUrls),
                lang: LANG_NUM_MAP[props.language]
            },
            {
                group: null
            }
        );
        const newsUniqueIds = uniq(uniqueIDData.newsUniqueId);

        // 通过新闻唯一ID获取新闻信息，newsUniqueId => newsInfo
        const newsInfoList = await commonApiRequest.get(
            'newsInfoList',
            {
                newsUniqueIds: safeStringify(newsUniqueIds),
                lang: LANG_NUM_MAP[props.language]
            },
            {
                group: null
            }
        );
        newsInfoList.forEach((item) => newsInfoMap.set(item.newsUniqueId, item));
        const resData = [];
        // 接口返回的数据顺序与传入的id顺序不同，需手动调整顺序
        newsUniqueIds.forEach((id, idx) => {
            if (newsInfoMap.has(id) && isCurrentAreaUrl(customUrls[idx])) {
                resData.push(newsInfoMap.get(id));
            }
        });
        return resData;
    }

    function getListData() {
        return {
            [NEWS_TYPE.MARKET]: getMarketData,
            [NEWS_TYPE.STOCK]: getNewsStockData,
            [NEWS_TYPE.CUSTOM]: getNewsData
        };
    }

    return {
        getListData
    };
}
